export const PROTOCOL_VERSION = '1.0.0';
export { BUILD_ID } from './build-info.js';
export { PROTOCOL_WIRE_VERSION } from './envelope.js';
export { ProtocolEnvelopeBaseSchema } from './envelope.js';
export * from './messages.js';
export { canonicalJson, computeStateHash } from './state-hash.js';
//# sourceMappingURL=index.js.map